import { useMemo } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { useAiReport } from "../../hooks/useAiReport";
import { prepareAiReportHtml } from "../../utils/aiReportHtml";

export default function AiReportPanel({ groupId, reportDays }: { groupId: number; reportDays: number[] }) {
  const report = useAiReport(groupId, reportDays);
  const reportHtml = useMemo(() => report.html ? prepareAiReportHtml(report.html) : "", [report.html]);
  const reportDate = report.updatedAt ? new Date(report.updatedAt).toLocaleString("ru-RU") : null;

  return (
    <section className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_16px_42px_rgba(15,23,42,0.08)]">
      <div className="flex flex-wrap items-center justify-between gap-4 border-b border-slate-100 p-5">
        <div>
          <h2 className="text-lg font-semibold">ИИ-отчёт</h2>
          {reportDate && <p className="mt-1 text-sm text-slate-500">Дата отчёта: <time dateTime={report.updatedAt!}>{reportDate}</time></p>}
        </div>
        <div className="flex flex-wrap gap-3">
          {report.canGenerate && <button type="button" onClick={report.refresh} disabled={report.running || report.busy || Boolean(report.error)}
            className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60">
            <RefreshCw size={16} /> Сгенерировать отчёт
          </button>}
        </div>
      </div>
      <div aria-live="polite">
        {(report.message || report.busy) && (
          <div className="flex items-center gap-3 bg-indigo-50 px-5 py-4 text-sm text-indigo-800" role="status">
            {(report.busy || (report.running && !report.timedOut && !report.error)) && <Loader2 size={18} className="shrink-0 animate-spin" />}
            <span>{report.message || "Загружаем ИИ-отчёт…"}</span>
          </div>
        )}
        {report.error && <div role="alert" className="bg-amber-50 px-5 py-4 text-sm text-amber-800">{report.error}</div>}
      </div>
      {report.html && (
        <iframe title="ИИ-отчёт" sandbox="allow-scripts" srcDoc={reportHtml}
          style={{ width: "100%", minHeight: "80vh", border: 0 }} />
      )}
    </section>
  );
}
